import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex gap-2" }

import { ref, reactive, computed, inject } from "vue";
  import dayjs from "dayjs";
  import axios from "axios";

  
export default {
  __name: 'SpecificDateOpeningHours',
  props: {
    initialValues: {
      type: Object,
      default: () => ({
        specificDate: null,
        startTime: null,
        endTime: null,
        comment: null,
      }),
    },
    modalId: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  const props = __props;

  const specificDateError = ref(null);
  const timeError = ref(null);
  const commentError = ref(null);

  const minDate = computed(() => dayjs().format("YYYY-MM-DD"));

  const date = ref(
    props.initialValues.specificDate ? dayjs(props.initialValues.specificDate.date).format("YYYY-MM-DD") : ""
  );

  const times = reactive({
    from: props.initialValues.startTime ? dayjs(props.initialValues.startTime.date).format("HH:mm") : null,
    to: props.initialValues.endTime ? dayjs(props.initialValues.endTime.date).format("HH:mm") : null,
  });

  const comment = ref(props.initialValues.comment ?? null)

  const validateTimeFormat = (time) => {
    if (!time) return true;
    return /^([01][0-9]|2[0-3]):[0-5][0-9]$/.test(time);
  };

  const validateTimes = () => {
    if (!times.from && !times.to) {
      timeError.value = null;
      return true;
    }

    if (!times.from || !times.to) {
      timeError.value = "Beide Zeiten müssen gesetzt sein";
      return false;
    }

    if (!validateTimeFormat(times.from) || !validateTimeFormat(times.to)) {
      timeError.value = "Ungültiges Zeitformat";
      return false;
    }

    if (times.from >= times.to) {
      timeError.value = "Endzeit muss nach Startzeit liegen";
      return false;
    }

    timeError.value = null;
    return true;
  };

  const validateDate = () => {
    if (!date.value) {
      specificDateError.value = null;
      return true;
    }

    const selectedDate = dayjs(date.value);
    const today = dayjs().startOf("day");

    if (selectedDate.isBefore(today)) {
      specificDateError.value = "Das Datum darf nicht in der Vergangenheit liegen";
      return false;
    }

    specificDateError.value = null;
    return true;
  };

  const validateComment = () => {
    if (comment.value && comment.value.length > 25) {
      commentError.value = "Maximal erlaubte Länge 25 Zeichen";
      return false;
    }

    commentError.value = null;
    return true;
  }

  const saveUrl = inject("saveUrl");
  const onSubmit = async (event) => {
    event.preventDefault();

    if (!date.value) {
      specificDateError.value = "Bitte geben Sie ein Datum an";
      return false;
    }

    if (!validateDate()) {
      return false;
    }

    if (!validateTimes()) {
      return false;
    }

    try {
      const payload = {
        type: "specificDates",
        entries: [
          {
            id: props.initialValues.id,
            specificDate: date.value,
            from: times.from,
            to: times.to,
            comment: comment.value,
          },
        ],
      };

      await axios.post(saveUrl, payload);
      window.location.reload();
      return true;
    } catch (error) {
      console.error("Failed to save specific date:", error);
      return false;
    }
  };

return (_ctx, _cache) => {
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_b_form_group = _resolveComponent("b-form-group")
  const _component_b_form = _resolveComponent("b-form")
  const _component_b_modal = _resolveComponent("b-modal")

  return (_openBlock(), _createBlock(_component_b_modal, {
    id: __props.modalId,
    title: __props.initialValues.id ? 'Öffnungszeiten bearbeiten' : 'Öffnungszeiten erstellen',
    "ok-title": "Speichern",
    "cancel-title": "Abbrechen",
    onOk: onSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_b_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_b_form_group, {
            class: "mb-2",
            label: "Datum",
            state: specificDateError.value === null ? null : specificDateError.value === true,
            "invalid-feedback": specificDateError.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                modelValue: date.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((date).value = $event)),
                type: "date",
                min: minDate.value,
                required: "",
                onInput: validateDate
              }, null, 8 /* PROPS */, ["modelValue", "min"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state", "invalid-feedback"]),
          _createVNode(_component_b_form_group, {
            class: "mb-2",
            label: "Öffnungszeiten",
            state: times.from || times.to ? timeError.value === null : null,
            "invalid-feedback": timeError.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_b_form_input, {
                  modelValue: times.from,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((times.from) = $event)),
                  type: "time",
                  placeholder: "Öffnungszeit",
                  onInput: validateTimes
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(_component_b_form_input, {
                  modelValue: times.to,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((times.to) = $event)),
                  type: "time",
                  placeholder: "Schließzeit",
                  onInput: validateTimes
                }, null, 8 /* PROPS */, ["modelValue"])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state", "invalid-feedback"]),
          _createVNode(_component_b_form_group, {
            label: "Bemerkung",
            state: commentError.value === null ? null : commentError.value === true,
            "invalid-feedback": commentError.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_form_input, {
                modelValue: comment.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((comment).value = $event)),
                type: "text",
                onInput: validateComment
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state", "invalid-feedback"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["id", "title"]))
}
}

}